import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import ParticipantForm from "../components/AddParticipant/ParticpantForm";


const EditParticipant = () => {

    useEffect(() => {
        document.title = "Edit Participant"
    }
        , []);

    const { id } = useParams();

    return (

        <div className="row justify-content-center">
            <div className="column-medium-10">
                <ParticipantForm id={id} />
            </div>
        </div>
    )

}
export default EditParticipant;
